function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M95,34.1l-5,11.9h2.6l0.9-2.3h5.2l0.9,2.3h2.7l-5-11.9L95,34.1z M94.4,41.4l1.7-4.3l1.8,4.3H94.4z M33.7,45.9 h2.6V34.1h-2.6V45.9z M121,43.6h-5.5v-2.5h5c0-0.4-0.1-0.8-0.1-1.3c0-0.4,0-0.7,0-1.1h-5v-2.4h5.4c0.2-0.8,0.5-1.6,0.9-2.3h-8.9 v11.9h8.9C121.5,45.2,121.2,44.4,121,43.6 M25.7,34.1h-2.6v11.9h8.4v-2.4h-5.8V34.1z M44.9,33.7c-3.4,0-6.2,2.8-6.2,6.2 c0,3.5,2.7,6.4,6.1,6.4c3.5,0,6.3-2.8,6.3-6.3C51.1,36.5,48.3,33.7,44.9,33.7 M44.9,43.8c-2.1,0-3.7-1.7-3.7-3.8 c0-2.1,1.6-3.8,3.8-3.8c2.1,0,3.7,1.7,3.7,3.8C48.6,42.2,47,43.8,44.9,43.8 M72.5,39.1c-1.7-0.6-3.4-0.9-3.4-2 c0-0.7,0.7-1.2,2.1-1.2c1.4,0,3,0.6,4,1.2v-2.5c-1.4-0.6-2.8-1-4.2-1c-2.8,0-4.8,1.4-4.8,3.6c0,2.3,1.9,3.1,3.3,3.6 c1.7,0.6,3.3,0.9,3.3,2c0,0.7-0.8,1.2-2.2,1.2c-1.3,0-3-0.6-4-1.2v2.5c1.5,0.6,2.8,0.9,4.2,0.9c2.9,0,4.9-1.4,4.9-3.6 C75.7,40.5,73.9,39.6,72.5,39.1 M83.5,41.7h3.4c-0.2,0.9-1,2.2-3.2,2.2c-2.2,0-3.9-1.7-3.9-3.9c0-2.2,1.7-3.9,3.9-3.9 c2.3,0,3.3,1.8,3.3,1.9l2-1.3c-1.2-1.9-3.1-3-5.3-3c-3.5,0-6.4,2.8-6.4,6.3c0,3.5,2.8,6.3,6.3,6.3c3.3,0,5.8-2.4,5.8-5.6v-1.4h-6 V41.7z M61.3,41.4l-5.5-7.3h-2.4v11.9H56v-7.5l5.7,7.5h2.2V34.1h-2.6V41.4z M101.3,36.5h3.6v9.4h2.6v-9.4h3.6v-2.4h-9.7V36.5z"
});

var SvgLogoLionsgate = function SvgLogoLionsgate(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 145 80",
    style: {
      enableBackground: "new 0 0 145 80"
    },
    xmlSpace: "preserve"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/logo-lionsgate.9e7b96b3.svg";
export { SvgLogoLionsgate as ReactComponent };